<template>
  <!-- 添加群聊组件 -->
  <div class="p-absolute top-0 right-0 bottom-0 left-0 bg-black-0-2" v-show="visible">
      <div class="p-absolute m-auto top-0 right-0 bottom-0 left-0 p-t-25 r-2 bg-white shadow-5-g-400 z-index-3" style="width: 70%; height: 90%;border-radius: 5px;">
          <p style="position:absolute; top:0; left:0; padding-top:10px; padding-left:10px; width:100%; text-align:left;padding-bottom: 17px; color:#999999; border-bottom: 1px solid #E8E8E9;font-size:14px;">聊天记录</p>
          <i class="el-icon-close y-fs-18 y-c-p y-fc-999 p-absolute top-5 right-10" @click="close"></i>
          <div class="p-relative f-left h-100-p bg-white b-r b-c-150" style="width:100%;    margin-top: 20px;border-radius: 5px;">
            <!-- 全部 -->
            <div class="o-auto p-b-20 left-personnel-box historyScrollContainer" style="height:92%;">
              <ul style="padding-top:0.1px;" class="historyScroll">
                <li style=" margin-top: 10px;   background: #fff;width: 98%;margin-left: 10px;border-bottom: 1px solid #E8E8E9;" class="p-y-10 flex cursor-pointer"  v-for="(item,index) in forData" :key="index">
                  <div class="d-table-cell v-a-middle h-100-p w-64"  style="text-align: center;">
                  <span v-if="item.from.length==32" style="width:40px;height:40px;border: 1px solid #f2f3f4;line-height: 40px;display:inline-block;font-size: 12px;" class="c-white rounded bg-violet">{{getShortNickname(item.fromNick||"")}}</span>
                  <img v-if="item.from.length!=32&&item.fromNick!='小圆'" src="@/assets/images/im/kefu.svg" style="width:40px;height:40px;"/>
                  <img v-if="item.from.length!=32&&item.fromNick=='小圆'" src="@/assets/images/im/xiaoyuan.png"  style="width:40px;height:40px;"/>
                  </div>
                  <div class="content" style="width:91%;">
                    <div class="flex header" style="color:#999">
                      <div class="w-80 w-s-nowrap t-o-ellipsis o-hidden">{{item.fromNick}}</div>
                      <div>{{timeHandler(item.time,true)}}</div>
                  </div>
                  <div class="m-r-4 m-t-10" style="width:94%;word-break: break-all;">
                    <p v-if="item.type==0||item.type=='text'" v-html="iconhandler(item.body)"></p>
                    <!--视频-->
                    <!--图片-->
                    <el-image style="max-width: 150px; height: auto"  :src="JSON.parse(item.attach).url.replace(/:10080/,'')"
                        :preview-src-list="[JSON.parse(item.attach).url.replace(/:10080/,'')]" v-if="item.type==1||item.type=='image'">
                    </el-image>
                    <div v-if="(item.type==6||item.type=='file')&&!((item.type==6||item.type=='file')&&(JSON.parse(item.attach).ext.toLowerCase()=='mp4'
                    ||JSON.parse(item.attach).ext.toLowerCase()=='ogv'||JSON.parse(item.attach).ext.toLowerCase()=='webm'||JSON.parse(item.attach).ext.toLowerCase()=='ogg'||
                    JSON.parse(item.attach).ext.toLowerCase()=='mov'||JSON.parse(item.attach).ext.toLowerCase()=='mkv'||JSON.parse(item.attach).ext.toLowerCase()=='mpeg'
                    ||JSON.parse(item.attach).ext.toLowerCase()=='mp3'||JSON.parse(item.attach).ext.toLowerCase()=='wav'))" style="max-width: 360px; display: flex; align-items: center; cursor: pointer;position:relative;padding: 15px 0;" @mouseover="donwloadfilePicShow(item)" @mouseout="donwloadfilePicHide(item)"  @click="downloadFile(item)" class="cursor-pointer">
                      <img src="@/assets/images/im/filelog.png" style="width: 28px; height: 36px;">
                      <div style="max-width: 280px; color: #653EB3;">
                        <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 280px; padding-left: 10px;" class="t-d-underline">
                          {{JSON.parse(item.attach).name}}
                        </div>
                        <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 280px; padding-left: 10px;">
                          {{changeByte(JSON.parse(item.attach).size)}}
                        </div>
                      </div>
                      <div style="position: absolute;width: 100%;height: 80%;left: 0px;    border-radius: 6px;background: rgb(51, 51, 51,0.2);" v-show="item.donwloadfilePicShowFlag"> <div style="display: flex;justify-content: center;align-items: center;height: 100%;"><img src="@/assets/images/im/downloadFile.png" class="information" style="width:30px;height:30px;"/></div></div>
                    </div>
                    </div>
                    <div class="c-g-250 cursor-pointer" v-if="(item.type === 'custom'||item.type === 100) && item.attach && JSON.parse(item.attach).type == 15">
                      <div v-if="JSON.parse(item.attach).data&&(JSON.parse(item.attach).data.md5)">
                      <div>
                        <p style="color:#666;border-bottom: 1px solid;    margin-bottom: 5px;padding-bottom: 5px;">聊天记录</p>
                        <p style="color:#999;max-width:100%;height: 20px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;"><span class="color: #333;margin-right: 7px;">{{JSON.parse(item.attach).data.messageAbstract[0].sender}}:</span><span>{{JSON.parse(item.attach).data.messageAbstract[0].message}}</span></p>
                        <p style="color:#999;max-width:100%;height: 20px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;" v-if="JSON.parse(item.attach).data.messageAbstract.length>1"><span class="color: #333;margin-right: 7px;">{{JSON.parse(item.attach).data.messageAbstract[1].sender}}:</span><span>{{JSON.parse(item.attach).data.messageAbstract[1].message}}</span></p>
                      </div>
                      </div>
                    </div>
                    <video v-if="(item.type==3||item.type=='video')||((item.type==6||item.type=='file')&&(JSON.parse(item.attach).ext.toLowerCase()=='mp4'
                    ||JSON.parse(item.attach).ext.toLowerCase()=='ogv'||JSON.parse(item.attach).ext.toLowerCase()=='webm'||JSON.parse(item.attach).ext.toLowerCase()=='ogg'||JSON.parse(item.attach).ext.toLowerCase()=='mov'||JSON.parse(item.attach).ext.toLowerCase()=='mkv'))" class="cursor-pointer" controls="true" style="width: 200px; height: 200px;">
                        <source type="video/mp4" :src="JSON.parse(item.attach).url.replace(/:10080/,'')">
                        <source type="video/ogg" :src="JSON.parse(item.attach).url.replace(/:10080/,'')">
                        <source type="video/webm" :src="JSON.parse(item.attach).url.replace(/:10080/,'')">
                      </video>
                      <!--语音-->
                      <audio v-if="(item.type==2||item.type=='audio')||((item.type==6||item.type=='file')&&(JSON.parse(item.attach).ext.toLowerCase()=='mpeg'
                    ||JSON.parse(item.attach).ext.toLowerCase()=='mp3'||JSON.parse(item.attach).ext.toLowerCase()=='wav'||JSON.parse(item.attach).ext.toLowerCase()=='ogg'))" style="padding: 3px;background-color: #fff;" class="cursor-pointer" controls="true">
                        <source type="video/mpeg" :src="JSON.parse(item.attach).url.replace(/:10080/,'')">
                        <source type="video/wav" :src="JSON.parse(item.attach).url.replace(/:10080/,'')">
                        <source type="video/ogg" :src="JSON.parse(item.attach).url.replace(/:10080/,'')">
                      </audio>
                  </div>
                </li>
              </ul>
            </div>
          </div>
      </div>
  </div>
</template>
<script>
/**
    var typeMap = {
      text: 0,
      image: 1,
      audio: 2,
      video: 3,
      geo: 4,
      notification: 5,
      file: 6,
      tip: 10,
      robot: 11, // robotIn
      // robotOut: 12,
      g2: 12,
      custom: 100
    }
**/
import emoticonArr from './util/emoticon.js';
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    teamlevel: {
      type: Number,
      default: 200
    },
    historyData:{
      type: Object,
      default: function () {
        return {};
      }
    },
    scenceTo:{
      type: Object,
      default: function () {
        return {};
      }
    },
    myAccountData:{
      type: Object,
      default: function () {
        return {};
      }
    },
    toCustomData:{
      type: Object,
      default: function () {
        return {};
      }
    },
    toTeamData:{
      type: Object,
      default: function () {
        return {};
      }
    },
    firstHistoryData:{
      type: Array,
      default: function () {
        return [];
      }
    },
    userInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    im: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data: function () {
    return {
      date: new Date(),
      ulHeight:false,
      visible: false,
      scrollflag:true,
      forData:[],
      emoticonArr,
      historyForwardFlag:false
    };
  },
  components: {
  },
  mounted: function () {
    
  },
  methods: {
    // 处理表情符号
    iconhandler(text) {
      if(!text) return text;
      var $this = this,
        arrStore = [];
      text.replace(/\[([^\[]+)\]/g, function (str) {
        arrStore.push(str);
      });
      arrStore.forEach(function (element) {
        var index = text.indexOf(element),
          len = element.length,
          name = element.replace(/\[|\]/g, ''),
          src = '';
        for (var i = 0; i < $this.emoticonArr.length; i++) {
          if ($this.emoticonArr[i].name === name) {
            src = $this.emoticonArr[i].src;
            break;
          }
        }
        if (src) {
          var str = text.substring(0, index);
          str += `<img src="${src}"  width="20" style="width:20px;height:20px;vertical-align: middle; margin: -3px 3px 0 3px;">`;
          str += text.substring(index + len);
          text = str;
        }
      });
      return text;
    },
    // 补0
    coverFirst: function (str) {
      str = str + '';
      if (str.length === 1) str = '0' + str;
      return str;
    },
    // 设置时间字符串
    timeHandler: function (time, isTodayText) {
      var date = new Date(time),
        year = date.getFullYear(),
        mouth = date.getMonth() + 1,
        day = date.getDate(),
        hour = date.getHours(),
        minute = date.getMinutes(),
        str = '';
      if (year !== this.date.getFullYear()) str = year + '年' + this.coverFirst(mouth) + '月' + this.coverFirst(day) + '日 ';
      else if (mouth !== this.date.getMonth() + 1 || day !== this.date.getDate()) str = this.coverFirst(mouth) + '月' + this.coverFirst(day) + '日 ';
      else if (isTodayText) str = '今天 ';
      str += this.coverFirst(hour) + ':' + this.coverFirst(minute);
      return str;
    },
    changeByte:function (limit){
      var size = "";
      if(limit < 0.1 * 1024){                            //小于0.1KB，则转化成B
          size = limit.toFixed(2) + "B"
      }else if(limit < 0.1 * 1024 * 1024){            //小于0.1MB，则转化成KB
          size = (limit/1024).toFixed(2) + "KB"
      }else if(limit < 0.1 * 1024 * 1024 * 1024){        //小于0.1GB，则转化成MB
          size = (limit/(1024 * 1024)).toFixed(2) + "MB"
      }else{                                            //其他转化成GB
          size = (limit/(1024 * 1024 * 1024)).toFixed(2) + "GB"
      }
  
      var sizeStr = size + "";                        //转成字符串
      var index = sizeStr.indexOf(".");                    //获取小数点处的索引
      var dou = sizeStr.substr(index + 1 ,2)            //获取小数点后两位的值
      if(dou == "00"){                                //判断后两位是否为00，如果是则删除00
          return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
      }
      return size;
    },
    downloadFile(data){
      let item = JSON.parse(data.attach);
      axiosHttpIm.get(item.url.replace(/:10080/,''), {
        responseType: 'blob'
      }).then(function (res) {
        let blob = new Blob([res], {
          type: res.type
        }); //创建Blob对象;
        let link = document.createElement('a'); //创建a标签;
        let filename = item.name;
        link.href = window.URL.createObjectURL(blob); //创建对象超链接;
        link.download = filename; //设置下载excel文件名称;
        // 配置下载的文件名
        if (navigator.userAgent.indexOf("Firefox") > -1) {
          document.body.appendChild(link); //把a标签添加到body后面;
          link.click(); //触发a标签点击事件;
          link.remove();
        } else {
          link.click();
        }
      }).catch(function(){});
    },
    donwloadfilePicShow(data){
      this.$set(data,'donwloadfilePicShowFlag',true)
    },
    donwloadfilePicHide(data){
      this.$set(data,'donwloadfilePicShowFlag',false)
    },
    // 截取名称后俩位
    getShortNickname: function (name) {
      if(!name) return;
      var len = name.length;
      return name.slice(len - 2, len);
    },
    getData(){
      this.bus.$on('openHistoryForward',(data)=>{
        console.log(data,'0888');
      })
    },
    // 打开、关闭组件
    open: function (val,flag) {
      this.historyForwardFlag = flag;
      console.log(val,'0821');
      this.forData = val;;
      if (this.visible) return;
      this.visible = true;
      this.navSelctType = '0';
      this.ulHeight = false;
      this.scrollflag = true;
      this.oldScrollTop = 0;
      // this.crearePrivateTeam();
    },
    close: function () {
      this.oldScrollTop = 0;
      this.visible = false;
      // 重置选择组件
      this.value = '';
      if(this.historyForwardFlag){
        this.$parent.zIndex = 999;
      }
    },
    format: function (timestamp,type) {
      //time是整数，否则要parseInt转换
      var time = new Date(timestamp),
        nowDate = new Date(),
        y = time.getFullYear(),
        m = time.getMonth() + 1,
        d = time.getDate(),
        h = time.getHours(),
        mm = time.getMinutes(),
        s = time.getSeconds();
      if (y + "" + m + "" + d + "" == nowDate.getFullYear()+""+(nowDate.getMonth()+1)+""+nowDate.getDate()) {
        if(type == 0){
          return "今天"
        }else if(type == 1){
          return this.add(h) + ':' + this.add(mm) + ':' + this.add(s)
        }
      }
      return y + '-' + this.add(m) + '-' + this.add(d);
  },
  add: function (m) {
    return m < 10 ? '0' + m : m
  },
  changeByte:function (limit){
    var size = "";
    if(limit < 0.1 * 1024){                            //小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B"
    }else if(limit < 0.1 * 1024 * 1024){            //小于0.1MB，则转化成KB
        size = (limit/1024).toFixed(2) + "KB"
    }else if(limit < 0.1 * 1024 * 1024 * 1024){        //小于0.1GB，则转化成MB
        size = (limit/(1024 * 1024)).toFixed(2) + "MB"
    }else{                                            //其他转化成GB
        size = (limit/(1024 * 1024 * 1024)).toFixed(2) + "GB"
    }

    var sizeStr = size + "";                        //转成字符串
    var index = sizeStr.indexOf(".");                    //获取小数点处的索引
    var dou = sizeStr.substr(index + 1 ,2)            //获取小数点后两位的值
    if(dou == "00"){                                //判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
    }
    return size;
  },
  },
  watch: {
  },
  computed: {}
}
</script>
